<template>
    <div>
        <div v-for="(user, i) in paginatedSortedFees"
             :key="i"
             class="organization-list-body"
        >
            <div class="organization-list-body__item list-body__item--sorting">
                {{ user.name }}
            </div>
            <div class="organization-list-body__item" style="word-break: break-all">
                {{ user.email }}
            </div>
            <div class="organization-list-body__item">
                {{ user.role.name }}
            </div>
            <div class="organization-list-body__item">
                {{ user.lastLoginAt ? lastLogin(user.lastLoginAt) : '-' }}
            </div>
            <div class="organization-list-body__item">
                <history-button @click="goToHistory(user)" />
                <info-button @click="changeUser(user)" />
                <delete-button @click="deleteUser(user)"/>
            </div>
        </div>
        <div v-for="(user, i) in paginatedSortedFees"
             class="organization-list-body_mobile "
             :key="i + 'mobile'"
        >
            <div class="organization-list-body__item list-body__item--sorting">
                <div class="organization-list-body__wrapper-text">
                    <span>
                        <span>{{ user.name }}</span>
                        <span class="time">
                            ({{ user.lastLoginAt ? lastLogin(user.lastLoginAt) : '-' }})
                        </span>
                    </span>
                    <span>
                      <span>{{ user.role.name }}</span>
                      <span>{{user.email}}</span>
                    </span>
                </div>
            </div>
            <div class="organization-list-body__item organization-list-body__buttons">
                <base-button @click="goToHistory(user)" class="history-mobileBtn" type="secondary">
                    <template #prepend>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.99996 1.14258C6.24206 1.14759 4.55321 1.82755 3.28225 3.04201V1.82829C3.28225 1.64643 3.21001 1.47202 3.08141 1.34342C2.95281 1.21482 2.7784 1.14258 2.59654 1.14258C2.41467 1.14258 2.24026 1.21482 2.11166 1.34342C1.98307 1.47202 1.91082 1.64643 1.91082 1.82829V4.91401C1.91082 5.09587 1.98307 5.27028 2.11166 5.39888C2.24026 5.52748 2.41467 5.59972 2.59654 5.59972H5.68225C5.86411 5.59972 6.03853 5.52748 6.16712 5.39888C6.29572 5.27028 6.36796 5.09587 6.36796 4.91401C6.36796 4.73214 6.29572 4.55773 6.16712 4.42913C6.03853 4.30054 5.86411 4.22829 5.68225 4.22829H4.03654C4.91821 3.30694 6.09334 2.72154 7.35987 2.57275C8.62641 2.42396 9.90521 2.72107 10.9764 3.41301C12.0476 4.10494 12.8443 5.14846 13.2294 6.36415C13.6146 7.57984 13.5642 8.89173 13.0869 10.0743C12.6096 11.2568 11.7352 12.2361 10.614 12.8438C9.49287 13.4515 8.19504 13.6496 6.94366 13.4041C5.69228 13.1585 4.56554 12.4847 3.75717 11.4984C2.9488 10.5121 2.5093 9.27495 2.51425 7.99972C2.51425 7.81786 2.44201 7.64344 2.31341 7.51485C2.18481 7.38625 2.0104 7.31401 1.82854 7.31401C1.64667 7.31401 1.47226 7.38625 1.34366 7.51485C1.21507 7.64344 1.14282 7.81786 1.14282 7.99972C1.14282 9.35593 1.54499 10.6817 2.29846 11.8093C3.05193 12.937 4.12287 13.8159 5.37585 14.3349C6.62883 14.8539 8.00757 14.9897 9.33773 14.7251C10.6679 14.4605 11.8897 13.8074 12.8487 12.8485C13.8077 11.8895 14.4608 10.6676 14.7253 9.33748C14.9899 8.00733 14.8541 6.62858 14.3351 5.3756C13.8161 4.12263 12.9372 3.05169 11.8096 2.29821C10.6819 1.54474 9.35618 1.14258 7.99996 1.14258ZM7.99996 5.25686C7.8181 5.25686 7.64369 5.32911 7.51509 5.4577C7.38649 5.5863 7.31425 5.76071 7.31425 5.94258V7.99972C7.31425 8.18158 7.38649 8.356 7.51509 8.48459C7.64369 8.61319 7.8181 8.68543 7.99996 8.68543H9.37139C9.55325 8.68543 9.72767 8.61319 9.85627 8.48459C9.98486 8.356 10.0571 8.18158 10.0571 7.99972C10.0571 7.81786 9.98486 7.64344 9.85627 7.51485C9.72767 7.38625 9.55325 7.31401 9.37139 7.31401H8.68568V5.94258C8.68568 5.76071 8.61343 5.5863 8.48484 5.4577C8.35624 5.32911 8.18183 5.25686 7.99996 5.25686Z" :fill="'#6750A4'"/>
                        </svg>
                    </template>
                    <template #label>
                        <span class="history-mobileBtn--label">{{ $t('profits.history') }}</span>
                    </template>
                </base-button>
                <info-button @click="changeUser(user)" />
                <delete-button @click="deleteUser(user)"/>
            </div>
        </div>
        <pagination :page-size="pageSize" :current="page" @page-change="paginate"
                    :total="sortedFees.length"/>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import pagination from "@/public/components/common/uiKit/Pagination.vue";
import _ from "lodash";
import DeleteButton from "@/public/components/common/uiKit/delete-button/index.vue";
import InfoButton from "@/public/components/common/uiKit/info-button/index.vue";
import HistoryButton from "@/public/components/common/uiKit/history/index.vue";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";

export default {
    name: 'OrganisationListBody',

    components: {
        BaseButton,
        HistoryButton,
        InfoButton,
        DeleteButton,
        pagination,
    },

    data() {
        return {
            page: 1,
            pageSize: 10,
        };
    },

    methods: {
        ...mapActions('app', ['openModal']),

        deleteUser(user) {
            this.openModal({
                name: 'RemoveUserModal',
                payload: {
                    user,
                },
            });
        },

        changeUser(user) {
            this.openModal({
                name: 'UpdateUserModal',
                payload: {
                    user,
                },
            });
        },
        goToHistory (user) {
            this.$router.push(`/authorization-history/${user.id}/${user.email}`)
        },

        lastLogin(date) {
            return new Date(date).toLocaleDateString();
        },

        paginate(page) {
            this.page = page;
        },
    },

    computed: {
        ...mapState('organizations', [
            'listUsers',
        ]),

        sortedFees() {
            return _.sortBy(this.listUsers);
        },

        paginatedSortedFees() {
            return this.sortedFees.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
        },
    },
};
</script>

<style lang="scss" scoped>
.history-mobileBtn--label {
    margin-left: 10px;
    color: var(--new-front-purple);
}
.organization-list-body {
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr) .75fr;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
    &__buttons {
        display: grid;
        grid-template-columns: 1fr 50px 50px;
        gap: 10px;
        padding-left: 20px;
        .base-btn {
            background: transparent !important;
            border: 1px solid #744DB2 !important;
            transition: background .2s ease !important;
            min-width: 48px;
            width: 77%;
            &:hover {
                background: var(--new-front-bg-btn-secondary-bg-modal-primary-hover) !important;
            }
        }
    }
  &_mobile {
    display: none;
    grid-template-columns: 1fr 1fr;

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;

      padding-top: 5px;
      border-bottom: 1px solid var(--new-front-divider-color);
    }
  }

  &__wrapper-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
      width: 100%;
      &__mobile-desc {
          margin-top: 8px;
      }
      @media (max-width: 556px) {
          padding: 20px 20px 0 0;
      }
    span {
      display: flex;
      align-items: center;
      justify-content: space-between;

      font-family: $Gilroy;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;

      line-height: 16px;

      &:first-child {
        color: var(--new-front-primary-font-color);
      }

      &:last-child {
        color: var(--new-front-secondary-font-color);
      }
    }
  }
    .time {
        font-family: $Gilroy;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 12px;
        color: var(--new-front-secondary-font-color);
    }
  &__item {
    font-family: $Gilroy;
    font-style: normal;
    font-weight: 500;
    font-size: $h4;
    line-height: 23px;
    min-height: 88px;
    //background: var(--secondary-color);
    //border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--new-front-divider-color);
    text-align: start;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--new-front-primary-font-color);


    @media screen and (max-width: 768px) {
      border-top: none;
      border-bottom: none;
      min-height: 68px;

      padding-left: 20px;
      padding-right: 20px;
    }

    &:first-of-type {
      padding-left: 25px;
    }

    &:last-of-type {
      justify-content: flex-end;
    }

    &-text {
        font-family: $Gilroy;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 16px;

      &_deposit {
        color: var(--green-200);
      }

      &_credit {
        color: var(--red-200);
      }
    }
  }

  &__icon {
    width: 60px;
    height: 40px;
    margin-right: 15px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s ease;

    @media screen and (max-width: 768px) {
      border-radius: 0;
      border: none;
    }

    &:hover {
      border: 1px solid #0059F7;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 1330px) {
  .transactions-list-body {
    &__item {
      &:first-of-type {
        padding-left: 15px;
      }

      &:last-of-type {
        padding-right: 15px;
      }
    }
  }

}

@media screen and (max-width: 950px) {
  .transactions-list-body {
    display: none;

    &_mobile {
      display: block;
      margin-top: 10px;
    }

  }

}

.list-body__item--sorting {
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
}
</style>
